module.exports = __webpack_public_path__ + "img/used-car-gt-r-nismo.9f67c3a5.jpg";